module.exports = __webpack_public_path__ + "img/Spotify_Icon.4187bddc.png";